import { defineMessages } from 'react-intl'

export default defineMessages({
  emailPlaceholder: {
    id: 'login.emailPlaceholder',
    defaultMessage: 'Email'
  },
  passwordPlaceholder: {
    id: 'login.passwordPlaceholder',
    defaultMessage: 'Password'
  },
  loginButton: {
    id: 'login.loginButton',
    defaultMessage: 'Log in'
  },
  googleLoginButton: {
    id: 'login.googleLoginButton',
    defaultMessage: 'Sign in with Google'
  },
  signupLink: {
    id: 'login.signupLink',
    defaultMessage: "Don't have an account? Sign up here"
  },
  welcomeBackTitle: {
    id: 'login.welcomeBackTitle',
    defaultMessage: 'Welcome Back'
  },
  welcomeBackSubtitle: {
    id: 'login.welcomeBackSubtitle',
    defaultMessage: 'Please enter your details to sign in.'
  },
  welcomeTitle: {
    id: 'login.welcomeTitle',
    defaultMessage: 'Welcome!'
  },
  welcomeDescription: {
    id: 'login.welcomeDescription',
    defaultMessage: 'You have successfully logged in'
  },
  errorTitle: {
    id: 'login.errorTitle',
    defaultMessage: 'Something wrong happened...'
  }
})
